import { createSelector } from 'reselect';

const getAuthStatus = state => state.status.auth;
const getVerifyStatus = state => state.status.verify;

export default createSelector(
  [getAuthStatus, getVerifyStatus],
  (authStatus, verifyStatus) => {
    return {
      authStatus,
      verifyStatus,
    };
  }
);



// WEBPACK FOOTER //
// ../shop_main/selector/auth.js